module.exports = __webpack_public_path__ + "img/wxcode.7a33a65e.png";